/**
 * Auf Web hängt expo-sqlite in openDatabaseAsync, ohne das Promise abzulehnen
 * (Worker-Antwort ist text/html). Die Fallliste darf darauf nicht warten.
 * Native liest lokale, noch nicht synchronisierte Fälle weiter mit.
 */
export function shouldReadOfflineCases(os: string): boolean {
  return os !== "web";
}
